const { uidispatcherInternal } = await import("uidispatcher_api/UidispatcherApiModule");
const GtmEventsConsumer = uidispatcherInternal.GtmEventsConsumer;
export default GtmEventsConsumer;
